import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Grid, Heart, User, LogOut } from 'lucide-react';
export function Sidebar() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navItems = [{
    icon: Home,
    label: 'Home',
    path: '/'
  }, {
    icon: Grid,
    label: 'Explore',
    path: '/explore'
  }, {
    icon: Heart,
    label: 'Favorites',
    path: '/favorites'
  }, {
    icon: User,
    label: 'Account',
    path: '/account'
  }];
  return <aside className="fixed left-0 top-0 h-screen w-20 bg-white border-r border-gray-200 flex flex-col items-center py-6 z-40 hidden md:flex" data-id="element-158">
      {/* Logo */}
      <Link to="/" className="mb-10 p-2 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-159">
        <img src="https://cdn.magicpatterns.com/uploads/hAt1egNjDXut8YhRxLuyhF/kithward.png" alt="Kithward" className="w-10 h-10 object-contain" data-id="element-160" />
      </Link>

      {/* Navigation */}
      <nav className="flex-1 flex flex-col gap-6 w-full px-2" data-id="element-161">
        {navItems.map(item => {
        const active = isActive(item.path);
        return <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center p-3 rounded-xl transition-all duration-200 group ${active ? 'bg-kithward-50 text-kithward-700' : 'text-gray-400 hover:text-kithward-700 hover:bg-gray-50'}`} data-id="element-162">
              <item.icon className={`w-6 h-6 mb-1 ${active ? 'stroke-[2.5px]' : 'stroke-2'}`} data-id="element-163" />
              <span className={`text-[10px] font-medium ${active ? 'text-kithward-700' : 'text-gray-400 group-hover:text-kithward-700'}`} data-id="element-164">
                {item.label}
              </span>
            </Link>;
      })}
      </nav>

      {/* Bottom Actions */}
      <div className="mt-auto pt-6 border-t border-gray-100 w-full px-2 flex justify-center" data-id="element-165">
        <button className="p-3 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-colors" data-id="element-166">
          <LogOut className="w-6 h-6" data-id="element-167" />
        </button>
      </div>
    </aside>;
}